import { Component, TemplateRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { Config } from "../../config.const";

@Component({
    selector: 'app-reset',
    templateUrl: './reset.html'
})
export class ResetComponent {

    @ViewChild('loading')
    loading: TemplateRef<any>;

    showErrorBox: boolean = false
    showInfoBox: boolean = false
    codice_fiscale:string
    message:string

    changing: Subscription;
    formGroup = new FormGroup({
        codice_fiscale: new FormControl(),
        vecchia: new FormControl(),
        nuova: new FormControl(),
        nuova2: new FormControl()
    });

    constructor(
        public activeModal: NgbActiveModal,
        private modalService: NgbModal
    ) { }

    async confirm() {
        this.showErrorBox = false
        this.showInfoBox = false

        const modalRef = this.modalService.open(
            this.loading,
            { backdrop: 'static' }
        );

        try {
            const request = await fetch(`${Config.baseURL}/reset-password-request`, {
                method: 'POST',
                mode: 'cors',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ codice_fiscale: this.codice_fiscale })
            });
            const response = await request.json()

            if (response.success) {
                this.showInfoBox = true
                this.activeModal.close()
            } else {
                this.showErrorBox = true
            }
            this.message = response.message

        } catch (err) {
        } finally {
            modalRef.close();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/opzioni/reset/reset.ts